import { useMemo } from 'react'
import { calcOpenPositionsTotalPnLPercent } from '../lib/tradeCalculations'
import type { Trade } from '../types/trade'
import DashboardWidgetTitle from './DashboardWidgetTitle'

interface DashboardWidgetTotalPnLProps {
  trades: Trade[]
}

const cardClass =
  'h-full w-full dashboard-card p-3 md:p-4 flex flex-col justify-center'

export default function DashboardWidgetTotalPnL({ trades }: DashboardWidgetTotalPnLProps) {
  const openTrades = useMemo(() => trades.filter((trade) => !trade.exit_date), [trades])
  const totalPnLPercent = useMemo(() => calcOpenPositionsTotalPnLPercent(openTrades), [openTrades])

  return (
    <div className={cardClass}>
      {/* Mobile: başlık ve değer yan yana */}
      <div className="flex md:hidden flex-row items-center justify-between gap-2 py-0.5">
        <p className="text-xs font-medium text-gray-500 uppercase tracking-wider truncate shrink-0">
          <DashboardWidgetTitle widgetId="totalPnLPercent" />
        </p>
        <p
          className={`text-base font-bold shrink-0 ${
            totalPnLPercent !== null
              ? totalPnLPercent >= 0
                ? 'text-green-600'
                : 'text-red-600'
              : 'text-gray-900'
          }`}
        >
          {totalPnLPercent !== null
            ? `${totalPnLPercent >= 0 ? '+' : ''}${totalPnLPercent.toFixed(2).replace('.', ',')}%`
            : '–'}
        </p>
      </div>
      {/* Desktop: üstte başlık, altta değer */}
      <div className="hidden md:block">
        <p className="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">
          <DashboardWidgetTitle widgetId="totalPnLPercent" />
        </p>
        <p
          className={`text-xl md:text-2xl font-bold ${
            totalPnLPercent !== null
              ? totalPnLPercent >= 0
                ? 'text-green-600'
                : 'text-red-600'
              : 'text-gray-900'
          }`}
        >
          {totalPnLPercent !== null
            ? `${totalPnLPercent >= 0 ? '+' : ''}${totalPnLPercent.toFixed(2).replace('.', ',')}%`
            : '–'}
        </p>
      </div>
    </div>
  )
}
